import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const governanceProjectsDirectoryRoute: InvariantJiraRoute = {
	name: 'governance-projects-directory',
	path: '/jira/settings/projects/policies',
	exact: true,
};
